import React from "react";
import Grid from '@mui/material/Grid2';
import LocalStorageService from '../../services/localStorage';
import {
    Box,
} from '@mui/material';
import './Header.css'

const localStorageService = LocalStorageService.getService();

const Header = ({isQuestionnaire}) => {

    const [logo, setLogo] = React.useState(null);

    const brandingInfo = localStorageService.getBrandingInfo();

    React.useEffect(() => {

        if (brandingInfo) {
            setLogo(JSON.parse(brandingInfo).branding)
        }

    }, [brandingInfo]);

    return (
        <Box component="section" className="headerBox">
            <Grid container className="container">
                <Grid item size={{ xs: 12, sm: 6, md: 3.3 }} style={{borderRight: '2px solid #004E87', padding: '5px 0'}} className="providers-header-logo">
                    <img src={logo} alt="BlueCross BlueSheild" style={{maxWidth: '220px'}} />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 8.7 }} className="providers-header">
                    <div className="providers-header-text">
                        {isQuestionnaire ? "Policy Questionnaire" : "Medical Policies"}                
                    </div>
                </Grid>
            </Grid>
        </Box>
    )

}
    

Header.propTypes = {
    isQuestionnaire: false,
};

export default Header;